import { AlertConnected } from "./AlertConnected";
export { useDispatchAlert, useDispatchClearMessages } from "./alertHooks"; 

export default AlertConnected;